// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { ISendInvoice } from '~/utils/interface/invoice';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      message: yup.string().trim().optional(),
      dueDate: yup.string().trim().optional(),
      fileIds: yup.array().optional(),
    })
    .required();
};

export const defaultValuesForm: ISendInvoice = {
  message: EMPTY_STRING,
  dueDate: EMPTY_STRING,
  fileIds: [],
  sendMode: EMPTY_STRING,
};
